import { useEffect, useRef, useState } from 'react';
import GiftCardEdit from './GiftCardEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import { Button, Popover, Select, Space, Tooltip } from 'antd';
import dayjs from 'dayjs';
import fetchApi from '../../../utils/api/fetchApi';
import AntdNotification from '../../../utils/extend/AntdNotification';
import getList from '../../../utilsTsx/universal/getList';
import { LoggerTypes } from '../../../bmCommonLibrary/bmDeclareTypes';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'giftCard';
    /** 当前打开的 Popover ID */
    const [activePopoverId, setActivePopoverId] = useState<string | null>(null);
    /** 当前打开的 Popover ID2 */
    const [activePopoverId2, setActivePopoverId2] = useState<string | null>(null);
    const [giftCardStatusData, setGiftCardStatusData] = useState<any>();
    const [giftCardSourceData, setGiftCardSourceData] = useState<any>();
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [fethcData, setFethcData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>({
        showPageData: {
            giftCardStatusId: 'allGiftCardStatus',
            giftCardSourceId: 'allGiftCardSource'
        }
    });

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setFethcData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService,
            {
                apiId: 'generalData',
                apiVariable: 'giftCardStatus@giftCardSource',
                apiExtend: 'showLists'
            }).then(res => {
                if (res.success) {
                    const { giftCardStatus, giftCardSource } = res.data;
                    setGiftCardStatusData([{ id: 'allGiftCardStatus', name: '所有' }, ...giftCardStatus]);
                    setGiftCardSourceData([{ id: 'allGiftCardSource', name: '所有' }, ...giftCardSource]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '方案',
            dataIndex: 'giftCardPlans',
            render: (val: any, record: any) => {
                let showText;
                if (val) {
                    showText = val.planName;
                } else {
                    try {
                        const backupJson = JSON.parse(record.backupStringify);
                        const { planName } = backupJson;
                        showText = planName;
                    } catch { }
                }
                return (<Tooltip placement="topLeft" title={showText}>{
                    (typeof showText !== "undefined" && showText !== null) ?
                        (showText.length >= 8 ? `${showText.substring(0, 8)}......` : showText)
                        : ''
                }</Tooltip>);
            }
        },
        {
            title: '礼品卡状态',
            dataIndex: 'giftCardStatusId',
            render: (val: string, record: any) => {
                let color;
                switch (record?.giftCardStatus?.id) {
                    case 0:
                        color = 'yellow';
                        break;
                    case -1:
                        color = 'red';
                        break;
                    case 2:
                        color = 'blue';
                        break;
                    default:
                        color = 'white';
                        break;
                }
                return (<><text style={{ color }}> {record?.giftCardStatus?.name}</text></>)
            },
            sorter: true
        },
        {
            title: '支付状态',
            dataIndex: 'paymentStatus',
            render: (text: any) => {
                let color;
                switch (text?.id) {
                    case 'Unpaid':
                        color = 'yellow';
                        break;
                    default:
                        color = 'white';
                        break;
                }
                return (<><text style={{ color }}> {text?.name}</text></>)
            }
        },
        {
            title: '结束期日',
            dataIndex: 'endDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: 'keyId',
            dataIndex: 'keyId',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 10 ? `${text.substring(0, 10)}......` : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '平台',
            dataIndex: 'platform',
            render: (text: any) => text?.name
        },
        {
            title: '关联id',
            dataIndex: 'associationId',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 10 ? `${text.substring(0, 10)}......` : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '来源',
            dataIndex: 'giftCardSource',
            render: (val: any, record: any) => val?.name
        },
        {
            title: '扣款',
            dataIndex: 'giftCardDeductionType',
            render: (val: any) => val?.name
        },
        {
            title: '',
            dataIndex: 'id',
            render: (id: string, record: any) => {
                if (record.paymentStatusId === 'Paid' && record.isUse === true) {
                    if (record.giftCardStatusId === 1) {
                        return (
                            <Popover
                                title="是否退款？"
                                trigger="click"
                                content={(<Space>
                                    <Button onClick={() => setActivePopoverId(null)}>否</Button>
                                    <Button type='primary' onClick={() => {
                                        fetchApi.PUT(defaultService,
                                            {
                                                apiId: 'giftCard',
                                                apiExtend: 'buyVoid',
                                                apiData: {
                                                    giftCardId: id
                                                }
                                            }).then(res => {
                                                if (res?.success === true) {
                                                    AntdNotification('success', '执行退款成功');
                                                    fethcData();
                                                } else {
                                                    AntdNotification('error', res?.message);
                                                }
                                            });
                                        setActivePopoverId(null);
                                    }}>是</Button>
                                </Space>)}
                                open={activePopoverId === id}
                                onOpenChange={(visible) => {
                                    setActivePopoverId(visible ? id : null);
                                }}
                            >
                                <Button type="default">退款</Button>
                            </Popover>
                        )
                    }

                    if (record.giftCardStatusId === 2) {
                        return (
                            <Popover
                                title="是否冲正？"
                                trigger="click"
                                content={(<Space>
                                    <Button onClick={() => setActivePopoverId2(null)}>否</Button>
                                    <Button type='primary' onClick={() => {
                                        fetchApi.PUT(defaultService,
                                            {
                                                apiId: 'giftCard',
                                                apiExtend: 'revokeRedeem',
                                                apiData: {
                                                    ids: [id]
                                                }
                                            }).then(res => {
                                                if (res?.success === true) {
                                                    AntdNotification('success', '执行冲正成功');
                                                    fethcData();
                                                } else {
                                                    AntdNotification('error', res?.message);
                                                }
                                            });
                                        setActivePopoverId2(null);
                                    }}>是</Button>
                                </Space>)}
                                open={activePopoverId2 === id}
                                onOpenChange={(visible) => {
                                    setActivePopoverId2(visible ? id : null);
                                }}
                            >
                                <Button type="default">冲正</Button>
                            </Popover>
                        )
                    }
                }
            }
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '礼品卡',
        apiId,
        columns,
        editOptions: {
            Editor: GiftCardEdit
        },
        expandableOptions: {
            subDataName: 'children',
            isSameMainDisplayOptions: true,
            isTree: true
        },
        serviceId: 'business',
        sendPageData,
        displayOptions: {
            showAdd: false,
            showUseBak: true,
            loggerProps: {
                showLogger: true,
                showSingleLogger: true,
                LoggerTypes,
                loggerTypeId: 'GIFTCARD'
            }
        }
    };

    return (
        <> <Space>
            <Select
                showSearch
                placeholder="礼品卡状态"
                optionFilterProp="children"
                defaultValue={'allGiftCardStatus'}
                onChange={(e) => {
                    const cs = {
                        showPageData: {
                            ...sendPageData.showPageData,
                            giftCardStatusId: e
                        }
                    }
                    setSendPageData(cs);
                    fethcData({
                        apiId,
                        sendPageData: cs
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(giftCardStatusData)}
            </Select>
            <Select
                showSearch
                placeholder="来源"
                optionFilterProp="children"
                defaultValue={'allGiftCardSource'}
                onChange={(e) => {
                    const cs = {
                        showPageData: {
                            ...sendPageData.showPageData,
                            giftCardSourceId: e
                        }
                    }
                    setSendPageData(cs);
                    fethcData({
                        apiId,
                        sendPageData: cs
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(giftCardSourceData)}
            </Select>
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;
